var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSquareCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2888 0.199951H1.71106C1.31029 0.199951 0.925934 0.359157 0.642545 0.642545C0.359157 0.925934 0.199951 1.31029 0.199951 1.71106V12.2888C0.199951 12.6896 0.359157 13.074 0.642545 13.3574C0.925934 13.6407 1.31029 13.8 1.71106 13.8H12.2888C12.6896 13.8 13.074 13.6407 13.3574 13.3574C13.6407 13.074 13.8 12.6896 13.8 12.2888V1.71106C13.8 1.31029 13.6407 0.925934 13.3574 0.642545C13.074 0.359157 12.6896 0.199951 12.2888 0.199951ZM5.48884 10.7777L1.71106 6.99995L2.7764 5.93462L5.48884 8.63951L11.2235 2.90484L12.2888 3.97773L5.48884 10.7777Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquareCheck);
export default __webpack_public_path__ + "static/media/icon--square-check.fa18084dfa3c54a687de5a786f3001d2.svg";
export { ForwardRef as ReactComponent };